import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const PrivateRoute = ({ children, roles }) => {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
            </div>
        );
    }

    if (!user) {
        // Redirect to landing page but save the current location they were trying to go to
        return <Navigate to="/landing" state={{ from: location }} replace />;
    }

    if (roles && !roles.includes(user.role)) {
        // Role not authorized, redirect to their default dashboard or home
        return <Navigate to="/" replace />;
    }

    return children;
};

export default PrivateRoute;
